import { Theme, ThemeUICSSObject } from 'theme-ui';
import { primary } from './primary';
import { information } from './information';
import { accordion } from './accordion';
import { print } from './print';
import { responsive } from './responsive';
import { secondary } from './secondary';
import { clean } from './clean';

export const tables: (theme: Theme) => ThemeUICSSObject = (theme) => {
  return {
    accordion,
    information,
    primary: primary(theme),
    print,
    responsive: responsive(theme),
    secondary,
    clean: clean(theme),
    /* PREPEND HERE */
  };
};
